<template>
  <div class="ad-box">
    <div class="ad-item" v-for="(item, index) in list" :key="index">
      <a :href="item.link" target="_blank"><img :src="item.url"/></a>
    </div>
  </div>
</template>

<script>
export default {
  props: ['middleAdList'],
  data() {
    return {
      list: []
    }
  },
  created() {
    if (this.middleAdList) {
      this.list = this.middleAdList
    }
  },
  watch: {
    middleAdList(val) {
      this.list = val
    }
  }
}
</script>

<style lang="scss" scoped>
.ad-box {
  .ad-item {
    height: 170px;
    width: 50%;
    background-repeat: no-repeat;
    background-position: center;
    padding-right:10px;
    display: inline-flex;
    img{
      width:100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/practice/ad/middle.vue